import useLiterals from 'utils/hooks/useLiterals';
import LogoImg from 'assets/logos/logo.png';
import backIcon from 'assets/icons/back.svg';
import useBack from 'hooks/useBack';
import { TERMS_INTRO, TERMS_SECTIONS } from './content';
import './styles.scss';

const TermsAndConditions = () => {
  const literals = useLiterals('termsAndConditions');
  const goBack = useBack(null, { listenNative: true });

  return (
    <div className='terms-and-conditions'>
      <button type='button' className='back-button' onClick={goBack}>
        <img src={backIcon} alt={literals.back} />
        <span>{literals.back}</span>
      </button>
      <img className='logo' src={LogoImg} alt='Montepío Luz Saviñón' />
      <h1 className='text-primary mb-4'>{literals.title}</h1>
      <div className='terms-content'>
        <p className='terms-intro'>{TERMS_INTRO}</p>
        {TERMS_SECTIONS.map((section) => (
          <section key={section.title} className='terms-section'>
            <h2>{section.title}</h2>
            {section.paragraphs?.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
            {section.bullets && (
              <ul>
                {section.bullets.map((bullet) => (
                  <li key={bullet}>{bullet}</li>
                ))}
              </ul>
            )}
            {section.trailingParagraphs?.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </section>
        ))}
      </div>
    </div>
  );
};

export default TermsAndConditions;
